// import "././node_modules/bootstrap/dist/css/bootstrap.min.css"
// import "././node_modules/bootstrap/dist/js/bootstrap.bundle"

// import "./src/style/style.scss";
// import "./src/style/_variables.scss";
// import "./src/style/responsive.scss";
// import "./static/fonts/all.min.css";

// import ReactDOM from "react-dom/client"
// import AOS from 'aos';

// AOS.init({
//     offset: 200,
//     delay: 100,
//     duration: 1500,
//     easing: 'ease-out',
//     once: true,
//     mirror: false,
//     anchorPlacement: 'top-bottom',
// });

// export const onRouteUpdate = () => {
//     window.scrollTo(0, 0);
// };

// export const replaceHydrateFunction = () => {

//     return (element, container) => {
//         const root = ReactDOM.createRoot(container)
//         root.render(element)
//     }
// }

import "././node_modules/bootstrap/dist/css/bootstrap.min.css";
import "././node_modules/bootstrap/dist/js/bootstrap.bundle";

import "./src/style/style.scss";
import "./src/style/_variables.scss";
import "./src/style/responsive.scss";
import "./static/fonts/all.min.css";

import ReactDOM from "react-dom/client";
import AOS from "aos";
import ReactGTM from "react-gtm-module";

AOS.init({
  offset: 200,
  delay: 100,
  duration: 1500,
  easing: "ease-out",
  once: true,
  mirror: false,
  anchorPlacement: "top-bottom",
});

export const onClientEntry = () => {
  // Initialize Google Tag Manager
  ReactGTM.initialize({ gtmId: "GTM-K93CDVTS" });
};

export const onRouteUpdate = () => {
  //   window.scrollTo(0, 0);

  // Optional: push pageview event to dataLayer for SPA navigation tracking
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "pageview",
      page: window.location.pathname,
    });
  }
};

export const replaceHydrateFunction = () => {
  return (element, container) => {
    const root = ReactDOM.createRoot(container);
    root.render(element);
  };
};
